import styled, { css } from 'styled-components';
import { colors } from '@ardoq/design-tokens';

const AGENT_PATH =
  'M1.777 15.178H0V11.535H1.777V15.178ZM10.666 15.178H8.888V11.535H10.666V15.178ZM8.888 11.535H1.777V9.714H8.888V11.535ZM7.11 2.82H8.887V6.463H7.11V8.284H3.555V6.463H7.109V2.821H3.555V1H7.11V2.82ZM3.555 6.463H1.777V2.82H3.555V6.463Z';

const encodedMaskSvg = encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 16"><path fill="white" d="${AGENT_PATH}"/></svg>`
);

const maskUrl = `url("data:image/svg+xml,${encodedMaskSvg}")`;

const maskStyles = css`
  mask-image: ${maskUrl};
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  -webkit-mask-image: ${maskUrl};
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  -webkit-mask-size: contain;
`;

const StyledAgentIconGradient = styled.span<{ $size: number }>`
  display: inline-block;
  flex-shrink: 0;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  background: linear-gradient(
    90deg,
    ${colors.orange400} 0%,
    ${colors.brand400} 100%
  );
  ${maskStyles}
`;

export type AgentIconGradientProps = {
  size?: number;
};

export const AgentIconGradient = ({ size = 22 }: AgentIconGradientProps) => (
  <StyledAgentIconGradient $size={size} aria-hidden="true" />
);
